import {Invoice} from '../../types/invoice';
import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {ResponseData} from 'types/response-data';

const duplicatInvoice = api.injectEndpoints({
  endpoints: builder => ({
    duplicatInvoice: builder.mutation<Response, Request>({
      query: params => {
        return {
          method: 'POST',
          url: `/invoices/${params.id}/duplicate`,
          body: {
            directory_id: params.directory_id,
          },
        };
      },
    }),
  }),
});

type Request = {
  id?: ObjectId;
  directory_id?: ObjectId;
};

type Response = ResponseData<Invoice>;

export const {useDuplicatInvoiceMutation} = duplicatInvoice;
